import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { showAlertModal } from './../../../../redux/helpers/';
import PageBackgroundColor from './page-background-color/PageBackgroundColor';

class Colors extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      opened: true,
      backgroundColorOpened: true,
      backgroundImageSelected: false,
    };
    this.clicked = false;
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      context,
      isSavedBook,
      setBackground,
    } = this.props;

    const { backgroundColorOpened, opened, backgroundImageSelected } = this.state;
    const ifConsumerAndNewBook = backgroundColorOpened && isSavedBook && !this.clicked;
    if (ifConsumerAndNewBook) {
      this.setState({
        backgroundColorOpened: !backgroundColorOpened,
        opened: !opened,
      });
    }
  }

  handleBackgroundImage = () => this.setState({
    backgroundColorOpened: !this.state.backgroundColorOpened,
    opened: !this.state.opened,
  })

  changeBackgroundSelected = () => {
    this.setState({
      backgroundImageSelected: true,
    });
  }

  changeDropDown = () => {
    const { opened } = this.state;
    const {
      backgroundType, lang, selectedBackgroundColor, backgroundImage, context,
    } = this.props;

    if ((backgroundType === '' && (selectedBackgroundColor === '' || backgroundImage === '') && context !== 'pro') || (backgroundType === 'tematikus' && backgroundImage === '')) {
      return showAlertModal(lang.title_notice, lang.select_background);
    }
    return this.setState({
      opened: !opened,
      backgroundColorOpened: false,
    });
  }

  changeSpineColorDropDown = () => {
    this.setState({
      backgroundColorOpened: false,
      opened: true,
    });
  }

  changeBackgroundColorDropDown = () => {
    this.clicked = true;
    const { backgroundColorOpened } = this.state;
    this.setState({
      backgroundColorOpened: !backgroundColorOpened,
      opened: true,
    });
  }


  render() {
    const {
      opened,
      backgroundColorOpened,
    } = this.state;

    const {
      pageId,
      pageOrder,
      lang,
      pages,
    } = this.props;


    const backgroundShow = backgroundColorOpened ? 'show' : '';
    return (
      <div className="colorWrapper">
        <div className={`marginWrapper ${backgroundShow}`}>
          <button ref={(backgroundButton) => { this.backgroundButton = backgroundButton; }} type="button" className="btn green-btn margin-btn" onClick={this.changeBackgroundColorDropDown.bind(this)}>
            <svg id="hatter" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
              <path id="Háttér" d="M3.731,0A2,2,0,0,1,2,1,2,2,0,0,1,0-1,1.994,1.994,0,0,1,1-2.731V-9.269A1.994,1.994,0,0,1,0-11a2,2,0,0,1,2-2,2,2,0,0,1,1.731,1h6.538A1.994,1.994,0,0,1,12-13a2,2,0,0,1,2,2,2,2,0,0,1-1,1.731v6.538A2,2,0,0,1,14-1a2,2,0,0,1-2,2,2,2,0,0,1-1.731-1ZM3-2.731A2,2,0,0,1,3.731-2h6.538A2,2,0,0,1,11-2.731V-9.269A2,2,0,0,1,10.269-10H3.731A2,2,0,0,1,3-9.269Z" transform="translate(0 13)" fill="#fff"/>
            </svg>
            {lang.background_color}
          </button>
          <div className={`dropdown-menu background-picker circle-picker ${backgroundShow}`}>
            <PageBackgroundColor
              pageId={pageId}
              pageOrder={pageOrder}
              lang={lang}
              pages={pages}
              handleOpen={this.handleBackgroundImage}
            />
          </div>
        </div>
        { opened ? <div onClick={this.changeDropDown.bind(this)} className="overlay" /> : ''}
      </div>
    );
  }
}

Colors.defaultProps = {
  pageId: 0,
  pageOrder: 0,
  lang: {},
  context: '',
  backgroundType: '',
  selectedBackgroundColor: '',
  backgroundImage: '',
  dispatch: () => {},
  isSavedBook: false,
};

Colors.propTypes = {
  pageId: PropTypes.number,
  pageOrder: PropTypes.number,
  lang: PropTypes.object,
  context: PropTypes.string,
  backgroundType: PropTypes.string,
  selectedBackgroundColor: PropTypes.string,
  backgroundImage: PropTypes.string,
  dispatch: PropTypes.func,
  isSavedBook: PropTypes.bool,
};

export default connect(state => ({
  spine: state.entities.cover.spine,
  context: state.bookProperties.context,
  backgroundType: state.editorUI.bookProperties.backgroundType,
  selectedBackgroundColor: state.editorUI.bookProperties.backgroundColor,
  backgroundImage: state.editorUI.bookProperties.backgroundImage,
  isSavedBook: state.editorUI.isSavedBook,
}))(Colors);



// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-buttons/colors/Colors.jsx